<script setup lang="ts">
/**
 * Пустое состояние списка уведомлений.
 * Свойство size: compact (default) — фиксированная высота для дропа,
 * full — тянется по высоте контейнера для страницы.
 */
withDefaults(defineProps<{
  size?: 'compact' | 'full'
}>(), {
  size: 'compact',
})
</script>

<template>
  <div
    class="notification-empty d-flex align-center justify-center text-medium-emphasis"
    :class="`notification-empty--${size}`"
  >
    <p class="notification-empty__text text-center">
      У вас нет новых уведомлений
    </p>
  </div>
</template>

<style lang="scss" scoped>
.notification-empty {
  inline-size: 100%;

  &--compact {
    padding-block: 24px;
  }

  &--full {
    min-block-size: 400px;
    padding-block: 48px;
  }

  &__text {
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    opacity: 0.6;
  }
}
</style>
